<template>
  <div :class="divWidthChange" class="conteudoWidth">
    <div class="row">
      <div class="col-sm-6">
        <span class="titlePage">{{ titlePage }}</span>
      </div>
      <div class="col-sm-6 text-right"></div>
    </div>
    <hr />
    <div class="row">
      <div class="col-sm-12">
        <fccTable
          striped
          hover
          :fields="fieldsGenero"
          responsive
          :porPage="itemPorPage"
          search
          pagination
          fieldVisibility
          pdf
          csv
          xls
          :titlePage="titlePage"
          :titlePDF="titlePDF"
          :actions="actionsGenero"
          addFilter
          :items="listarGenero"
        >
        </fccTable>
      </div>
    </div>
    <fccModal
      centered
      idModal="editArea"
      size="xl"
      :titleModal="titleModal"
      escondeFooter
      travaEsc
      travaBack
    >
      <form @submit.prevent="genero.idgenero === 0 ? addGenero() : editGenero()" autocomplete="off">
        <div class="row innerPage">
          <div class="col-sm-12">
            <fccInput extraClasses="inputLabel" v-model="genero.genero" required>Gênero</fccInput>
          </div>
        </div>
        <div class="row innerPage">
          <div class="col-sm-12">
            <b-form-textarea
              id="textarea"
              v-model="genero.texto"
              placeholder="Digite o descrivo"
              rows="3"
              max-rows="6"
            ></b-form-textarea>
          </div>
        </div>
        <div class="row innerPage">
          <div class="col text-left">
            <toggle-button v-model="genero.outro" />
            Contém outro
          </div>
        </div>
        <div class="row innerPage">
          <div class="col-sm-12 text-right">
            <fccButton classeAdd="form-control" tipo="submit">{{ labelsSystem.salvar }}</fccButton>
          </div>
        </div>
      </form>
    </fccModal>
  </div>
</template>
<script>
import axios from 'axios'
import store from '@/store'

export default {
  data() {
    return {
      sortBy: 'ordem',
      titlePage: 'Gênero',
      titleModal: '',
      titlePDF: 'Gênero',
      listarGenero: [],
      baseUrlConcursos: store.state.baseUrlConcursos,
      genero: [],
      itemPorPage: '100',
      actionsGenero: [
        {
          button: true,
          funcaoButton: 'editArea',
          icon: 'edit',
          tooltip: 'Editar',
          objpermCodigo: store.state.permissaoMenu.editar
        },
        {
          button: true,
          funcaoButton: 'deleteGenero',
          icon: 'trash',
          tooltip: 'Excluir',
          objpermCodigo: store.state.permissaoMenu.excluir
        }
      ],
      fieldsGenero: [
        { key: 'idgenero', label: 'ID', sortable: true, active: true },
        { key: 'genero', label: 'Código', sortable: true, active: true },
        {
          key: 'outro',
          label: 'Outro',
          sortable: true,
          active: true,
          type: 'toggle',
          funcaoButton: this.changeStatusOrdem,
          objpermCodigo: store.state.permissaoMenu.editar
        },
        { key: 'actions', label: '', tdClass: 'no-print', thClass: 'no-print', active: true }
      ]
    }
  },
  methods: {
    listandoGenero() {
      this.carregaTexto(this.codeMensagem('C01'))
      axios
        .get(
          this.baseUrlConcursos + 'CandidatoGenero/listar',
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          this.listarGenero = response.data
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto)
    },
    addField() {
      this.titleModal = 'Adicionar Gênero'
      this.genero = {}
      this.genero.idgenero = 0
      this.$root.$emit('bv::show::modal', 'editArea')
    },
    editArea(_, item) {
      this.titleModal = 'Editar Gênero'
      this.genero = item
      this.$root.$emit('bv::show::modal', 'editArea')
    },
    changeStatusOrdem(_, item) {
      this.genero = item
      this.editGenero()
    },
    editGenero() {
      this.carregaTexto(this.codeMensagem('C03'))
      axios
        .put(
          this.baseUrlConcursos + 'CandidatoGenero/Alterar',
          this.genero,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(() => {
          this.genero = {}
          this.callToast(this.mensagensUpdate.editado, 'success')
          this.$root.$emit('bv::hide::modal', 'editArea')
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto())
    },
    addGenero() {
      this.carregaTexto(this.codeMensagem('C03'))
      axios
        .post(
          this.baseUrlConcursos + 'CandidatoGenero/Adicionar',
          this.genero,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(() => {
          this.genero = {}
          this.listandoGenero()
          this.callToast(this.mensagensUpdate.adicionado, 'success')
          this.$root.$emit('bv::hide::modal', 'editArea')
        })
        .catch((error) => {
          this.setErrorSystem(error)
        })
        .finally(this.carregaTexto())
    },
    deleteGenero(_, item) {
      this.callConfirm(this.mensagemExcluir, item.descricao).then((result) => {
        if (result.value) {
          this.carregaTexto(this.codeMensagem('C03'))
          axios
            .delete(
              this.baseUrlConcursos + 'CandidatoGenero/Excluir/' + item.id,
              this.dadosLoginSession.fccTokenHeaders
            )
            .then(() => {
              this.listandoGenero()
              this.callToast(this.mensagensUpdate.excluido, 'success')
            })
            .catch((error) => {
              this.setErrorSystem(error)
            })
            .finally(this.carregaTexto())
        }
      })
    }
  },
  mounted() {
    this.listandoGenero()
  }
}
</script>
